
import { DropDownItem } from "@/models/Base/GlobalData";
import { Game } from "@/models/Game";
import { Season } from "@/models/GameType";
import { GoalsList, PlayTimerGoal } from "@/models/MapPois/Quest/Goals";
import { QuestMapPoi } from "@/models/MapPois/Quest/QuestMapPoi";
import { toArray } from "lodash";
import { Component, Vue, Prop } from "vue-property-decorator";
import AlertBoxEditable from "../../../Base/AlertBoxEditable.vue";

@Component({
  components: { AlertBoxEditable },
})
class ActionPlayTimerExit extends Vue {
  @Prop({ default: false }) readonly contentData!: GoalsList;
  @Prop({ default: false }) readonly isEditingLocked!: boolean;
  timeValue = 0;
  inclOffsetBool = false;
  playerGoalTimer: PlayTimerGoal = {
    timerVal: 0,
    inclOffset: false,
    parentID: "",
    status: "inactive",
  };

  created(): void {
    if (this.contentData?.playTimerGoal !== undefined) {
      this.timeValue = this.contentData.playTimerGoal.timerVal;
      this.inclOffsetBool = this.contentData.playTimerGoal.inclOffset;
    }
  }

  cancel(): void {
    this.$emit("cancel");
  }

  update(): void {
    this.playerGoalTimer.timerVal = this.timeValue;
    this.playerGoalTimer.inclOffset = this.inclOffsetBool;
    if (this.playerGoalTimer.timerVal == 0) {
      this.playerGoalTimer.status = "inactive";
      this.$emit("deleteAction");
    } else {
      this.playerGoalTimer.status = "active";
      this.$emit("update", this.playerGoalTimer);
    }
  }
  openClearDialog(): void {
    this.$bvModal.show("team-modal-alert-edit");
  }

  alertOk(): void {
    this.playerGoalTimer = {
      timerVal: 0,
      inclOffset: false,
      parentID: "",
      status: "inactive",
    };
    this.$emit("deleteAction");
  }
}

export default ActionPlayTimerExit;
